import { render, staticRenderFns } from "./OSCSettings.vue?vue&type=template&id=d8b83d34&"
import script from "./OSCSettings.vue?vue&type=script&lang=js&"
export * from "./OSCSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports